import { PoleId, PoleIndex, SunSailType } from "@biz/definitions/SunSailDefinitions";

export class FlexLogic {
  static isFlexC(sunSailType: SunSailType, poleId: PoleId): boolean {
    return sunSailType === SunSailType.SolidayFlex && poleId === PoleIndex.C;
  }
}